<template>

  <portlet
      :actionsBlock="false"
      :icon="'fal fa-alarm-clock'"
      :title="$t('menu.shifts')"
  >
    <template slot="portletBody">
      <ve-table
          v-if="getRealShifts.length"
          :max-height="400"
          height="400"
          width="100"
          :fixed-header="true"
          :expand-option="null"
          row-key-field-name="rowKey"
          :columns="getColumns"
          :cellSelectionOption="cellSelectionOption"
          :row-style-option="rowStyleOption"
          :event-custom-option="customEventOptions"
          :table-data="getRealShifts"/>
      <div v-else>{{ $t('shifts.table.noRecords') }}</div>
    </template>
  </portlet>
</template>

<script>
import {mapGetters} from "vuex";
import {customEventOptions} from "@/mixins/vueEasyTable/bodyCellEvents";
import {shiftFunctions} from "@/mixins/shifts/shiftFunctions";

export default {
  name: "ShiftsOverview",
  mixins: [customEventOptions, shiftFunctions],
  data() {
    return {
      cellSelectionOption: {
        enable: false,
      },
      virtualScrollOption: {
        enable: true,
      },
      rowStyleOption: {
        stripe: true,
        clickHighlight: true,
        hoverHighlight: true,
      }
    }
  },
  computed: {
    ...mapGetters('shifts', ['getShifts']),
    ...mapGetters('breaks', ['getBreaks']),
    getRealShifts() {
      return _.filter(this.getShifts, shift => {
        return !shift.fakeShift;
      })
    },
    getColumns() {
      return [
        {
          field: "name",
          key: '1',
          title: this.$t('shifts.name'),
          align: "left",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return (<div class="shift-name-cell">
              <div class="shift-name">{row.name}</div>
            </div>);
          }
        }, {
          field: "code",
          key: '2',
          title: this.$t('shifts.code'),
          align: "left"
        }, {
          field: "startTime",
          key: '3',
          title: this.$t('shifts.startTime'),
          align: "left"
        }, {
          field: "endTime",
          key: '4',
          title: this.$t('shifts.endTime'),
          align: "left",
          renderBodyCell: ({row, column, rowIndex}, h) => {
            return moment().set({hour: parseInt(row.endTime.split(':')[0]), minute: parseInt(row.endTime.split(':')[1]) }).add(1, 'minute').format('HH:mm')
          }
        }, {
          field: "actions",
          key: '5',
          title: this.$t('shifts.table.columns.actions'),
          align: "left",
          functions: [
            {id: 'delete-shift-button', handler: this.deleteShift},
            {id: 'edit-shift-button', handler: this.editShift},
            {id: 'manage-breaks-button', handler: this.manageBreaks
            }
          ],
          renderBodyCell: ({row, column, rowIndex}, h) => {
            const numberOfBreaks = _.filter(this.getBreaks.breaks, breakOfCompany => {
              return breakOfCompany.shifts.indexOf(row.id) > -1;
            }).length;
             return (<div class="row">
                    <div class="col-12 col-lg-4">
                      <button tag="delete-shift-button" class="btn shift-btn btn-danger btn-block">{this.$t('ui.delete')}</button>
                    </div>
                    <div class="col-12 col-lg-4">
                      <button tag="edit-shift-button" class="btn shift-btn btn-primary btn-block">{this.$t('ui.edit')}</button>
                    </div>
                   <div class="col-12 col-lg-4">
                     <button tag="manage-breaks-button" class="btn shift-btn btn-secondary btn-block">{this.$t('breaks.manage')} ({numberOfBreaks})</button>
                   </div>
                  </div>
              )
          }
        }
      ]
    },
  },
  methods: {
    manageBreaks($event) {
      this.$emit('manageBreaks', $event.row);
    },
    async editShift($event) {
      this.$emit('editShift', $event.row);
    },
    async deleteShift($event) {
      const deleteSwal = await this.$swal({
        title: this.$t("shifts.delete.swal.title"),
        html: this.$t("shifts.delete.swal.text", {name: $event.row.name}),
        icon: 'error',
        customClass: 'm-swal-delete',
        confirmButtonText: this.$t("shifts.delete.swal.confirm"),
        showCancelButton: true,
        cancelButtonText: this.$t('ui.cancel'),
        reverseButtons: true
      });
      if (deleteSwal.value) {
        await this.$store.dispatch('shifts/delete', $event.row.id);
        this.$toasted.global.successRequest(this.$t("shifts.delete.toast.success"))
      }
    }
  },
}
</script>

<style>
.shift-name-cell-deactivated, .shift-name-cell-future {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 1fr;
  grid-column-gap: 12px;
  grid-row-gap: 0px;
}

.shift-description[future] {
  background: #e2ffed;
}

.shift-description[deactivated] {
  background: #ffe0b8;
}

.shift-name {
  display: grid;
  align-content: center;
}

.shift-description {
  text-align: center;
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
  border-radius: 25px;
  padding-left: 1rem;
  padding-right: 1rem;
  font-weight: bold;
  font-size: 0.9em;
  display: grid;
  align-content: center;
  cursor: pointer;
}

.shift-btn {
  white-space: normal;
  height: 100%;
}
</style>